document.addEventListener('DOMContentLoaded', function () {
    const isMobile = helper.isMobile();
    productPage.init(isMobile);
    collectionPage.init();
    pandaPrivacyBanner.init()

    // const navInjector = new NavigationInjector();
    // navInjector.init();
});
const productPage = {
    init: function (isMobile) {
        const isOnProductPage = $('.template-product').length > 0;
        if (!isOnProductPage) {
            return
        }
        if (isMobile) {
            //this.enableStickyButton()
        }
        this.addEventListeners()
    }, enableStickyButton: function () {
        const cartButton = $('.btn-add-to-cart');
        const stickyCartButton = cartButton.clone();
        stickyCartButton.addClass('animate-bottom');
        stickyCartButton.addClass('stickyCartButton');
        $('.ajax-product-form').append(stickyCartButton);
        $(window).scroll(function () {
            const top_of_element = cartButton.offset().top;
            const bottom_of_element = cartButton.offset().top + cartButton.outerHeight();
            const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            const top_of_screen = $(window).scrollTop();
            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
                stickyCartButton.hide();
                stickyCartButton.attr('type', 'button');
                cartButton.attr('type', 'submit')
            } else {
                stickyCartButton.show();
                stickyCartButton.attr('type', 'submit');
                cartButton.attr('type', 'button')
            }
        })
    }, addEventListeners: function () {
        $(document).on('cartUpdated', async function (e, cartContent) {
            const currentCartValue = await theme.PandaCart.getCurrentCartValue(cartContent);
            const currentText = await theme.PandaCart.getShippingCostText(currentCartValue);
            $('.ShippingText').text(currentText)
        });
        $(window).on('cc-variant-updated', function (e, opts) {
            console.log('[Variant Title] Event triggered', opts);

            // Load variant metafields
            let variantMetafields = {};
            try {
                const metafieldsJson = document.getElementById('VariantMetafieldsJson');
                if (metafieldsJson) {
                    variantMetafields = JSON.parse(metafieldsJson.textContent);
                    console.log('[Variant Title] Loaded metafields:', variantMetafields);
                }
            } catch (error) {
                console.error('[Variant Title] Error parsing variant metafields:', error);
            }

            const allVariantOptions = [3];
            for (const variant of opts.product.variants) {
                for (let i = 0; i < variant.options.length; i += 1) {
                    if (!(allVariantOptions[i] && allVariantOptions[i].length > 0)) {
                        allVariantOptions[i] = []
                    }
                    if (!allVariantOptions[i].includes(variant.options[i])) {
                        allVariantOptions[i].push(variant.options[i])
                    }
                }
            }

            const options = opts.variant.options;
            const variantId = opts.variant.id;
            const variantMeta = variantMetafields[variantId] || {};

            console.log('[Variant Title] Variant ID:', variantId);
            console.log('[Variant Title] Variant meta:', variantMeta);
            console.log('[Variant Title] Product options:', opts.product.options);

            let titlePrefix = '';
            for (let i = 0; i < options.length; i += 1) {
                if (allVariantOptions[i].length > 1) {
                    const optionName = opts.product.options[i];
                    let optionValue = options[i];

                    console.log('[Variant Title] Processing option:', optionName, '=', optionValue);

                    // Use metafield value if option is "Modell" or "Größe"
                    if (optionName === 'Modell' && variantMeta.model_title_part) {
                        optionValue = variantMeta.model_title_part;
                        console.log('[Variant Title] Using model_title_part:', optionValue);
                    } else if (optionName === 'Größe' && variantMeta.size_title_part) {
                        optionValue = variantMeta.size_title_part;
                        console.log('[Variant Title] Using size_title_part:', optionValue);
                    }

                    titlePrefix += ' - ' + optionValue;
                }
            }

            console.log('[Variant Title] Final title prefix:', titlePrefix);
            $('.variant-product-title').html(titlePrefix)
        })
    }
};
const collectionPage = {
    init: function () {
        const isOnCollectionPage = $('.template-collection').length > 0;
        if (!isOnCollectionPage) {
            return
        }
        this.addEventListeners()
    }, addEventListeners: function () {
        $(document).on('filterChanged', async function (e, filterSearchParams) {
            const selectedFilters = $('.p-selected-filters');
            const filters = [];
            const parsed = new URLSearchParams(filterSearchParams);
            for (let parsedFilter of parsed) {
                if (!parsedFilter[0].startsWith('filter.p')) {
                    continue
                }
                let filterValue = parsedFilter[1];
                filters.push('<span>' + filterValue + ' </span>')
            }
            selectedFilters.empty();
            if (filters.length < 3) {
                for (const filter of filters) {
                    selectedFilters.append(filter)
                }
            }
        })
    }
};
const pandaPrivacyBanner = {
    init: function () {
    }, trackingDeclined: function () {
        const privacyCookie = $.cookie('_tracking_consent');
        if (!privacyCookie) {
            return false
        }
        const privacyCookieParsed = JSON.parse(privacyCookie);
        const trackingAllowed = privacyCookieParsed.con.CMP.a === "1" || privacyCookieParsed.con.CMP.a === 1
        return !trackingAllowed;
    }
};
const helper = {
    isMobile: function () {
        return window.matchMedia('only screen and (max-width: 768px)').matches
    }
};
